<template>
  <a-card title="Top Biller" :bordered="false">
    <a-skeleton :loading="loading" active>
      <chart-top-biller :chart-data="chartData" :options="options"></chart-top-biller>
    </a-skeleton>
  </a-card>
</template>

<script>
import ChartTopBiller from "./chart-top-biller";
export default {
  name: "chart-top-biller-container",
  components: {ChartTopBiller},
  props: {
    uri: {
      type: String,
      default: null
    }
  },
  mounted() {
    this.getItems()
  },
  data: () => ({
    loading: false,
    items: []
  }),
  methods: {
    getItems() {
      this.loading = true
      this.$http.get(this.uri !== null ? this.uri : this.routeUri('hyperion.transaction.summary.top-billers'))
        .then(res => (this.items = res.data))
        .catch(err => this.handleXhrError(err))
        .finally(() => this.loading = false)
    }
  },
  computed: {
    chartData() {
      const labels = this.items.map(item => item.biller_name)

      const data = {
        data: this.items.map(item => item.count),
        barThickness: 30,
        backgroundColor: Chart['colorschemes'].office.Civic6
      }

      return {
        labels: labels,
        datasets: [data]
      }
    },
    options() {
      return {
        scales: {
          xAxes: [{
            gridLines: {
              offsetGridLines: true
            },
            ticks: {
              stepSize: 100000
            }
          }]
        },
        legend: {
          display: false
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              return "Count: " + tooltipItem.xLabel
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
